import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
  border: 1px solid ${props => props.theme.colors.border.main};
  border-radius: ${props => props.theme.radius.md};
  padding: ${p => p.theme.app.padding.horizontal};
  justify-content: space-between;
  margin-bottom: 18px;
`;

export const Img = styled.div`
  width: 64px;
  height: 64px;
  border: 4px solid #ffffff;
  box-sizing: border-box;

  .ant-skeleton-avatar {
    width: 64px;
    height: 64px;
  }
`;
